import { IProductVariation } from 'src/interfaces/Product';

export const getVariationDisplayText = (
  variation?: IProductVariation,
  options: {
    showSizeName?: boolean;
    showFlavorName?: boolean;
    showProductCode?: boolean;
    showProductName?: boolean;
    nameOverride?: string;
  } = {},
): string => {
  const {
    showSizeName = true,
    showFlavorName = true,
    showProductCode = true,
    showProductName = true,
    nameOverride,
  } = options;

  const { product_code, name, productVariationSize, productVariationFlavor } =
    variation || {};

  const flavorName = productVariationFlavor?.name;
  const hasFlavor = flavorName && flavorName.toLowerCase() !== 'none'; // don't show flavor if none

  const parts = [
    showProductCode ? product_code : undefined,
    showProductName ? nameOverride || name : undefined,
    showSizeName ? productVariationSize?.name : undefined,
    showFlavorName && hasFlavor ? flavorName : undefined,
  ];

  return parts.filter(Boolean).join(' - ');
};
